import Vue from 'vue'
import Router from 'vue-router'

import home from '@/modules/home'
import know from '@/modules/know'
import detail from '@/modules/detail'
import videoList from '@/modules/videoList'
import videoDetail from '@/modules/videoDetail'
Vue.use(Router)
const router = new Router({
  routes: [
    
    {
      path: '/index',
      name: 'home',
      component: home,
      meta: {
        title: '易小淘易物结算系统官网',
        keepAlive:false
     }
    },
    {
      path: '/know',
      name: 'know',
      component: know,
      meta: {
        title: '了解易小淘',
        keepAlive:true,
        isBack: false
     }
    },
    {
      path: '/manage',
      name: 'manage',
      component: know,
      meta: {
        title: '易物站点经营',
        keepAlive:true,
        isBack: false
     }
    },
    {
      path:'/study',
      name:'study',
      component:know,
      meta: {
        title: '学习材料',
        keepAlive:true,
        isBack: false
     }
    },
    {
      path:'/notice',
      name:'notice',
      component:know,
      meta: {
        title: '系统公告',
        keepAlive:true,
        isBack: false
     }
    },
    {
      path:'/detail',
      name:'detail',
      component:detail,
      meta: {
        title: '文章详情',
        isBack: true,
        keepAlive:false
     }
    },

    {
      path:'/videoList',
      name:'videoList',
      component:videoList,
      meta: {
        title: '视频列表',
        keepAlive:true
     }
    },
    {
      path:'/videoDetail',
      name:'videoDetail',
      component:videoDetail,
      meta: {
        title: '视频详情',
        keepAlive:false
     }
    },
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: '易小淘易物结算系统官网',
        keepAlive:false
     }
    },
    
  ]
})

router.beforeEach(({ meta, path }, from, next) => {
  
  next()
})

router.afterEach(({ meta, path }, from, next) => {

  })
  

export default router



// WEBPACK FOOTER //
// ./src/router/index.js